
export function createSweepGradient(size, colorStops) {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");

  const cx = size / 2;
  const cy = size / 2;
  const imageData = ctx.createImageData(size, size);
  const data = imageData.data;

  // Normalize and parse color stops
  function parseColor(color) {
    const c = document.createElement("canvas").getContext("2d");
    c.fillStyle = color;
    const computed = c.fillStyle;
    let m = computed.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
    if (m) return { r: +m[1], g: +m[2], b: +m[3] };

    if (computed.startsWith("#")) {
      let hex = computed.slice(1);
      if (hex.length === 3) hex = hex.split("").map(x => x + x).join("");
      const int = parseInt(hex, 16);
      return {
        r: (int >> 16) & 255,
        g: (int >> 8) & 255,
        b: int & 255
      };
    }

    return { r: 255, g: 255, b: 255 }; // fallback
  }

  colorStops = colorStops
    .map(cs => ({ ...cs, rgb: parseColor(cs.color) }))
    .sort((a, b) => a.stop - b.stop);

  // Interpolate color between stops
  function getColorAt(t) {
    let i = 0;
    while (i < colorStops.length - 1 && t > colorStops[i + 1].stop) i++;

    let cs1 = colorStops[i];
    let cs2 = colorStops[(i + 1) % colorStops.length];

    let span = cs2.stop - cs1.stop;
    if (span <= 0) span += 1;

    let localT = (t - cs1.stop) / span;
    if (localT < 0) localT += 1;
    if (localT > 1) localT -= 1;

    return {
      r: Math.round(cs1.rgb.r + (cs2.rgb.r - cs1.rgb.r) * localT),
      g: Math.round(cs1.rgb.g + (cs2.rgb.g - cs1.rgb.g) * localT),
      b: Math.round(cs1.rgb.b + (cs2.rgb.b - cs1.rgb.b) * localT)
    };
  }

  // Render every pixel
  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      const dx = x - cx;
      const dy = y - cy;

      const angle = (Math.atan2(dy, dx) + Math.PI * 2) % (Math.PI * 2);

      const t = angle / (Math.PI * 2); // 0–1

      const c = getColorAt(t);

      const index = (y * size + x) * 4;
      data[index] = c.r;
      data[index + 1] = c.g;
      data[index + 2] = c.b;
      data[index + 3] = 255;
    }
  }

  ctx.putImageData(imageData, 0, 0);
  return canvas;
}
